import React from 'react';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import { OutlinedTextFields } from '../../../components/material-textField/texField';
import BoxDropdown from '../../../components/form-controls/outlinedDropdown';
import { change, Field, untouch } from 'redux-form';
import PropTypes from 'prop-types';
import { API_URL, API_URL_V2 } from '../../../utils/config';
import {
  CARD_SUPPORTED_ROUTING_CODE,
  CASH_PAYOUT_SUPPORTED_ROUTING_CODE,
  BRANCH_NAME,
  BRANCH_NAME_COUNTRIES,
  VISA_TNC_LINK,
  VISA_FAQ_LINKS
} from '../../../utils/constants';
import { r_maxLength } from '../../../utils/validation/restrictions';
import { connect } from 'react-redux';
import {
  cardExpiryValidation,
  visaDebitCardNoValidation,
  required
} from '../../../utils/validation';
import {
  saveNewBenificiary,
  getBankCodeORBranchNames
} from '../../../redux/actions/individual-user-flow/individual-user-flow-action';
import { encryptDataWithSignature } from '../../../utils/library';
import {
  replaceRecipientListItem,
  storeConfigBeneValidation
} from '../../../redux/actions/transaction/transaction-action';
import { getBeneficiaryByID } from '../../../redux/actions/common/common-action';
import { Link } from 'react-router-dom';
import { setCardNumberUpdate } from '../../../redux/actions/payee-data/payee-data-action';
import BankListSGNew from './BankListSGNew';
import some from 'lodash/some';
import get from 'lodash/get';
import {
  BankDetailsContainer,
  Title,
  StyledGrid,
  ButtonContainer,
  FastFundImage,
  VisaImage,
  LabelText,
  SaveButton,
  CardMessageContainer,
  FieldContainer,
  SwiftLink,
  SwiftMessageContainer,
  TNCText,
  FAQText,
  SwiftContainer,
  LabelTextNormal
} from './bankdetails.styled';
import styled from 'styled-components';
import IFSCFinder from './IFSCFinder';
import './ifsc-finder.scss';
import { ModalFactory } from '../../../components/modal/modal';
import InputField from '../../input/InputField';
import COLORS from '../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import { CLOSE_HEAVY_ICON, CORRECT_ICON, EDIT_ICON, NEW_ICON, VISA_SVG_ICON } from '@Images';
import { checkForTHBUnsupportedBank, renderTHBUnsupporteBankNote } from './utils';
import { validateStartsWithTwoUppercase } from '../../../screens/nium-forex/forex-pages/pan-verification/validation';
import { isEqual } from 'lodash';
import { FieldContainerBankFields } from '../../../screens/beneficiary-flow/pages/bank-details/styles';

export const IFSCSearchButton = styled.button`
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 8px;
  background-color: transparent;
  color: ${COLORS.black};
  padding: 0;
  text-decoration: underline;
  font-size: 14px;
  border: none;
  cursor: pointer;
  position: relative;
`;
const PayoutMethod = styled.div`
  height: 45px;
  display: flex;
  flex-direction: column;
`;

const RenderRecevingOptions = styled.div`
  ${({ isSingleRowField }) => (isSingleRowField ? 'max-width: 100%' : 'max-width: 325px')};
  @media only screen and (max-width: 1080px) {
    display: flex;
    justify-content: center;
    .innerBox {
      ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%' : 'width: 325px')};
    }
  }
`;

const RenderTitle = styled.div`
  height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${COLORS.black};
  display: flex;
  flex-direction: row;
`;

const SubTitle = styled.div`
  height: 19px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.textLightGrey};
`;

const NewIcon = styled.img`
  padding-left: 15px;
  ${(props) => props.style}
`;

const WalletWrapper = styled.div`
  .wallet-payout {
    margin-left: -10px;
  }
  .mobile-number-field-wrapper {
    flex: 1;
    margin-top: 8px;
  }
  .mobile-number-field {
    ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%' : ' width: 96%')};
    padding-left: 4%;
  }
  .mobile-field {
    display: flex;
    ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%' : 'width: 334px')};
    margin: 5px 0px;
  }
  p {
    color: #333;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
  }
  @media only screen and (max-width: 1080px) {
    ${({ isSingleRowField }) => (isSingleRowField ? 'width: 100%' : 'width: 323px')};
    margin: 0 auto;
    .wallet-payout {
      margin: -7px;
    }
  }
`;

const isBranchRequiredCountry = (p) => {
  const foundBranchNameCountry = BRANCH_NAME_COUNTRIES.find((e) => {
    return (
      e.currencyCode === p.currency_code &&
      e.bankAccountCountry === p.bank_account_country &&
      e.accountType.includes(p.account_type)
    );
  });

  return foundBranchNameCountry;
};
class BankDetailsBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderObject: null,
      reEnterLabel: null,
      debitCardFields: null,
      isDebitCardChecked: false,
      isBankChecked: false,
      isCardNumberUpdated: true,
      isWalletChecked: false,
      dropDown: [],
      showTHBUnsupportedNote: false,
      hasBankFieldValue: false
    };
  }
  fieldGenerator = (renderFields) => {
    if (!renderFields) {
      return {};
    }
    const renderObject = [];
    let reEnterLabel = '';
    let fields = [];
    Object.keys(renderFields).forEach((key) => {
      const field = renderFields[key];
      if (field && field instanceof Object) {
        const obj = field.render;
        if (obj.value_field_name === 'bank_account_number') {
          reEnterLabel = obj.label;
        }
        renderObject.push(
          Object.assign({}, obj, {
            validation: {
              ...(field.validation?.length || {}),
              required: field.validation?.required
            },
            onChange: {
              ...field.onChange
            },
            url: obj.url ? obj.url : field.url
          })
        );
      }
    });
    fields = renderObject.map((k) => k.value_field_name);
    this.props.getBankFields && this.props.getBankFields(fields);
    return {
      renderObject,
      reEnterLabel,
      fields
    };
  };

  resetOrEmptyGeneratedFields = (renderObject) => {
    renderObject.forEach((key) => {
      this.props.dispatch(change(this.props.formName, key.value_field_name, ''));
      this.props.dispatch(untouch(this.props.formName, key.value_field_name));
    });
  };
  async componentDidUpdate(prevProps) {
    const {
      renderFields,
      debitCardFields,
      formValues,
      beneCashPayoutDetails,
      beneWalletDetails,
      beneDetails,
      dispatch
    } = this.props;
    const dropDown = [];
    if (
      (beneCashPayoutDetails &&
        JSON.stringify(prevProps.beneCashPayoutDetails) !==
          JSON.stringify(this.props.beneCashPayoutDetails)) ||
      (debitCardFields &&
        JSON.stringify(prevProps.debitCardFields) !== JSON.stringify(this.props.debitCardFields)) ||
      (beneWalletDetails &&
        JSON.stringify(prevProps.beneWalletDetails) !==
          JSON.stringify(this.props.beneWalletDetails)) ||
      (renderFields &&
        JSON.stringify(prevProps.renderFields) !== JSON.stringify(this.props.renderFields))
    ) {
      if (beneCashPayoutDetails)
        dropDown.push({
          text: 'Cash pickup',
          subtitle: `${
            beneCashPayoutDetails.routing_config_type === 'CASH_PAYOUT'
              ? `Select cash pickup partner`
              : `Collect cash from available cash pickup partner`
          }`,
          value: `${
            beneCashPayoutDetails.routing_config_type === 'CASH_PAYOUT' ? `cash` : `money_cash`
          }`,
          key: 'cash'
        });
      if (debitCardFields)
        dropDown.push({
          text: 'Debit card',
          value: 'card',
          key: 'card',
          subtitle: 'Please provide recipient’s VISA debit card details '
        });
      if (beneWalletDetails)
        dropDown.push({
          text: 'Wallet',
          value: 'wallet',
          key: 'wallet',
          subtitle: "Please provide recipient's wallet details"
        });
      if (renderFields)
        dropDown.push({
          text: 'Bank deposit',
          value: 'bank',
          key: 'bank',
          subtitle: 'Please provide recipient’s bank account details'
        });
      if (dropDown && dropDown.length > 1) {
        this.setState({
          dropDown
        });
        dispatch(change(this.props.formName, 'details_selected', null));
        dispatch(change(this.props.formName, 'bank_card_validations', null));
        dispatch(storeConfigBeneValidation(null));
      } else if (dropDown && dropDown.length === 1) {
        this.setState({
          dropDown: []
        });
        const value = dropDown[0].value;
        const validation =
          value === 'card'
            ? this.props.debit_validations
            : value === 'bank'
            ? this.props.bank_validations
            : value === 'wallet'
            ? this.props.wallet_validations
            : null;
        dispatch(change(this.props.formName, 'details_selected', value));
        dispatch(change(this.props.formName, 'bank_card_validations', validation));
        dispatch(storeConfigBeneValidation(validation));
      }
    } else if (this.props.currency_code !== prevProps.currency_code) {
      this.setState({
        dropDown: []
      });
      let value = 'bank';
      if (beneCashPayoutDetails && !renderFields && !debitCardFields) {
        value = `${
          beneCashPayoutDetails.routing_config_type === 'CASH_PAYOUT' ? `cash` : `money_cash`
        }`;
      }
      const validation =
        value === 'card'
          ? this.props.debit_validations
          : value === 'bank'
          ? this.props.bank_validations
          : value === 'wallet'
          ? this.props.wallet_validations
          : null;
      this.props.dispatch(change(this.props.formName, 'details_selected', value));
      this.props.dispatch(change(this.props.formName, 'bank_card_validations', validation));
      dispatch(storeConfigBeneValidation(validation));
    }
    if (JSON.stringify(prevProps.renderFields) !== JSON.stringify(this.props.renderFields)) {
      const { renderObject, reEnterLabel } = this.fieldGenerator(renderFields);
      await this.setState({
        renderObject,
        reEnterLabel,
        isBankChecked: true,
        isDebitCardChecked: false,
        isWalletChecked: false
      });
    }
    if (
      debitCardFields &&
      JSON.stringify(prevProps.debitCardFields) !== JSON.stringify(this.props.debitCardFields)
    ) {
      const { renderObject: debitRenderObject, reEnterLabel: debitEnterLabel } = this.fieldGenerator(
        debitCardFields.BANK_DETAIL
      );
      await this.setState({
        debitRenderObject,
        debitEnterLabel,
        debitCardFields,
        isBankChecked: false,
        isDebitCardChecked: true,
        isWalletChecked: false
      });
      this.props.dispatch(
        change(this.props.formName, 'card_type', get(debitCardFields, 'routing_config_type'))
      );
    }
    if (formValues && formValues.card_number !== prevProps.formValues.card_number) {
      this.props.dispatch(change(this.props.formName, 'fast_fund_message', ''));
      this.props.dispatch(change(this.props.formName, 'show_visa_icon', ''));
    }
    if (
      JSON.stringify(prevProps.beneWalletDetails) !== JSON.stringify(this.props.beneWalletDetails)
    ) {
      const { renderObject, reEnterLabel: walletEnterLabel } = this.fieldGenerator(beneWalletDetails);
      await this.setState({
        walletRenderObject: renderObject,
        walletEnterLabel,
        isBankChecked: false,
        isDebitCardChecked: false,
        isWalletChecked: true
      });
    }
    if (
      beneDetails &&
      beneDetails.routing_config_type === 'WALLET' &&
      ((beneDetails.routing_code_value_1 &&
        beneDetails.routing_code_value_1 !== beneDetails.formValues?.routing_code_value_1) ||
        (formValues &&
          formValues.routing_code_value_1 &&
          formValues.routing_code_value_1 !== prevProps.formValues?.routing_code_value_1))
    ) {
      this.props.dispatch(
        change(
          this.props.formName,
          'routing_code_value_1',
          formValues.routing_code_value_1 || beneDetails.routing_code_value_1
        )
      );
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const formValuesChanged = !isEqual(this.props.formValues, nextProps.formValues);

    const renderFieldsChanged = !isEqual(this.props.renderFields, nextProps.renderFields);
    const debitCardFieldsChanged = !isEqual(this.props.debitCardFields, nextProps.debitCardFields);
    const currencyChanged = this.props.currency_code !== nextProps.currency_code;
    const stateChanged = !isEqual(this.state, nextState);

    const shouldUpdate =
      formValuesChanged ||
      renderFieldsChanged ||
      debitCardFieldsChanged ||
      currencyChanged ||
      stateChanged;

    return shouldUpdate;
  }

  handleCheck = (item, show) => {
    checkForTHBUnsupportedBank({
      currencyCode: this.props.currency_code,
      item,
      show,
      onResult: (isSupported) => {
        this.setState({ showTHBUnsupportedNote: !isSupported });
      }
    });
  };

  componentDidMount = async () => {
    const {
      renderFields,
      debitCardFields,
      isPartiallyEditable,
      isCompleteEditable,
      beneCashPayoutDetails,
      beneWalletDetails,
      dispatch,
      isVopTransactionFlow,
      isNewBeneAddFlow,
      formValues
    } = this.props;
    const bankName = this.props.formValues?.bank_name;

    if (this.props.currency_code === 'THB' && bankName) {
      this.setState({ hasBankFieldValue: true });
      this.handleCheck(bankName, true);
    }
    const dropDown = [];
    if (beneCashPayoutDetails)
      dropDown.push({
        text: 'Cash pickup',
        subtitle: `${
          beneCashPayoutDetails.routing_config_type === 'CASH_PAYOUT'
            ? `Select cash pickup partner`
            : `Collect cash from available cash pickup partner`
        }`,
        value: `${
          beneCashPayoutDetails.routing_config_type === 'CASH_PAYOUT' ? `cash` : `money_cash`
        }`,
        key: 'cash'
      });
    if (debitCardFields)
      dropDown.push({
        text: 'Debit card',
        value: 'card',
        key: 'card',
        subtitle: 'Please provide recipient’s VISA debit card details '
      });
    if (beneWalletDetails)
      dropDown.push({
        text: 'Wallet',
        value: 'wallet',
        key: 'wallet',
        subtitle: "Please provide recipient's wallet details"
      });
    if (renderFields)
      dropDown.push({
        text: 'Bank deposit',
        value: 'bank',
        key: 'bank',
        subtitle: 'Please provide recipient’s bank account details'
      });

    if (formValues?.details_selected && (isVopTransactionFlow || isNewBeneAddFlow)) {
      this.payoutMethodSelected(null, formValues?.details_selected);
    } else if (dropDown && dropDown.length > 1) {
      this.setState({
        dropDown
      });
      this.props.dispatch(change(this.props.formName, 'details_selected', null));
      this.props.dispatch(change(this.props.formName, 'bank_card_validations', null));
      dispatch(storeConfigBeneValidation(null));
    } else if (dropDown && dropDown.length === 1) {
      this.setState({
        dropDown: []
      });
      const value = dropDown[0].value;
      const validation =
        value === 'card'
          ? this.props.debit_validations
          : value === 'bank'
          ? this.props.bank_validations
          : value === 'wallet'
          ? this.props.wallet_validations
          : null;
      this.props.dispatch(change(this.props.formName, 'details_selected', value));
      this.props.dispatch(change(this.props.formName, 'bank_card_validations', validation));
      dispatch(storeConfigBeneValidation(validation));
    }
    if (renderFields) {
      const { renderObject, reEnterLabel } = this.fieldGenerator(renderFields);
      await this.setState({
        renderObject,
        reEnterLabel,
        isBankChecked: true,
        isDebitCardChecked: false,
        isWalletChecked: false
      });
    }
    if (beneWalletDetails) {
      const { renderObject, reEnterLabel: walletEnterLabel } = this.fieldGenerator(beneWalletDetails);
      await this.setState({
        walletRenderObject: renderObject,
        walletEnterLabel,
        isBankChecked: false,
        isDebitCardChecked: false,
        isWalletChecked: true
      });
    }
    if (debitCardFields) {
      const generated = this.fieldGenerator(debitCardFields.BANK_DETAIL);
      let debitRenderObject = generated.renderObject;
      const debitEnterLabel = generated.reEnterLabel;
      if (CARD_SUPPORTED_ROUTING_CODE.includes(this.props.formValues.routing_config_type)) {
        debitRenderObject = debitRenderObject.map((debitRender) => ({
          ...debitRender,
          ...{ disabled: true }
        }));
        if (isPartiallyEditable || isCompleteEditable) {
          this.setState({ isCardNumberUpdated: false });
          this.props.dispatch(change(this.props.formName, 'is_card_number_updated', false));
        }
      }
      await this.setState({
        debitRenderObject,
        debitEnterLabel,
        debitCardFields,
        isBankChecked: false,
        isDebitCardChecked: true,
        isWalletChecked: false
      });
      this.props.dispatch(
        change(this.props.formName, 'card_type', get(debitCardFields, 'routing_config_type'))
      );
      const isCardIssueNameExists = some(debitRenderObject, (item) => {
        return item.value_field_name === 'card_issuer_name';
      });
      if (!isCardIssueNameExists) {
        this.props.dispatch(change(this.props.formName, 'card_issuer_name', ''));
      }
    }
    if (this.props.formValues.routing_config_type === 'BANK') {
      this.setState({
        isBankChecked: true,
        isDebitCardChecked: false,
        isWalletChecked: false
      });
      this.props.dispatch(change(this.props.formName, 'details_selected', 'bank'));
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.bank_validations)
      );
      dispatch(storeConfigBeneValidation(this.props.bank_validations));
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange('bank');
    } else if (CARD_SUPPORTED_ROUTING_CODE.includes(this.props.formValues.routing_config_type)) {
      this.setState({
        isBankChecked: false,
        isDebitCardChecked: true,
        isWalletChecked: false
      });
      this.props.dispatch(change(this.props.formName, 'details_selected', 'card'));
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.debit_validations)
      );
      dispatch(storeConfigBeneValidation(this.props.debit_validations));
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange('card');
    } else if (
      CASH_PAYOUT_SUPPORTED_ROUTING_CODE.includes(this.props.formValues.routing_config_type)
    ) {
      const selected =
        this.props.formValues.routing_config_type === 'CASH_PAYOUT' ? 'cash' : 'money_cash';
      this.props.dispatch(change(this.props.formName, 'details_selected', selected));
      this.props.dispatch(change(this.props.formName, 'bank_card_validations', null));
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange(selected);
    } else if (this.props.formValues.routing_config_type === 'WALLET') {
      this.setState({
        isBankChecked: false,
        isDebitCardChecked: false,
        isWalletChecked: true
      });
      this.props.dispatch(change(this.props.formName, 'details_selected', 'wallet'));
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.wallet_validations)
      );
      dispatch(storeConfigBeneValidation(this.props.wallet_validations));
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange('wallet');
    }
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    if (nextProps.renderFields && nextProps.renderFields !== this.props.renderFields) {
      const { renderObject, reEnterLabel } = this.fieldGenerator(nextProps.renderFields, 'nex bank');
      await this.setState({ renderObject, reEnterLabel });
    }

    if (
      nextProps.beneWalletDetails &&
      nextProps.beneWalletDetails !== this.props.beneWalletDetails
    ) {
      const { renderObject, reEnterLabel: walletEnterLabel } = this.fieldGenerator(
        nextProps.beneWalletDetails
      );
      await this.setState({
        walletRenderObject: renderObject,
        walletEnterLabel
      });
    }

    if (nextProps.debitCardFields) {
      if (nextProps.debitCardFields !== this.props.debitCardFields) {
        const { renderObject: debitRenderObject, reEnterLabel: debitEnterLabel } =
          this.fieldGenerator(nextProps.debitCardFields.BANK_DETAIL, 'nex card');
        this.resetOrEmptyGeneratedFields(debitRenderObject);
        await this.setState({
          debitRenderObject,
          debitEnterLabel,
          debitCardFields: nextProps.debitCardFields
        });
      }
    } else {
      await this.setState({
        debitRenderObject: null,
        debitEnterLabel: null,
        debitCardFields: null
      });
    }

    if (nextProps.currency_code !== this.props.currency_code) {
      const { renderObject, reEnterLabel } = this.fieldGenerator(nextProps.renderFields, 'wtf ar u');
      this.resetOrEmptyGeneratedFields(renderObject);
      await this.setState({
        renderObject: renderObject,
        reEnterLabel: reEnterLabel
      });
    }
  };

  BankAccountCountryChange = (obj, key) => {
    this.props.dispatch(change(this.props.formName, key, obj.value));
    this.props.dispatch(untouch(this.props.formName, key, obj.value));
  };
  enableCardEdit = () => {
    this.setState(
      {
        isCardNumberUpdated: true
      },
      () => this.props.setCardNumberUpdate(true)
    );
    const { isPartiallyEditable, isCompleteEditable } = this.props;
    this.props.dispatch(change(this.props.formName, 'is_card_number_updated', true));
    this.props.dispatch(change(this.props.formName, 'fast_fund_message', ''));
    let debitRenderObject = this.state.debitRenderObject;
    debitRenderObject = debitRenderObject.map((key) => {
      const valueFieldName = key.value_field_name;
      if (isPartiallyEditable || isCompleteEditable) {
        this.setState({
          [`${valueFieldName}_backup`]: this.props.formValues[valueFieldName]
        });
      }
      this.props.dispatch(change(this.props.formName, key['value_field_name'], ''));
      return { ...key, ...{ disabled: false } };
    });

    this.setState({
      debitRenderObject
    });
  };

  renderDebitCard = () => {
    const { debitRenderObject, isCardNumberUpdated } = this.state;
    const {
      formValues: { fast_fund_message = '', show_visa_icon },
      errors = {},
      isSingleRowField
    } = this.props;
    if (debitRenderObject) {
      // eslint-disable-next-line array-callback-return
      const debitCardRenderHtml = debitRenderObject.map((key, index) => {
        if (key.visible) {
          switch (key.type) {
            case 'text': {
              const isFieldDisabled = key.disabled || false;
              const validationArray =
                key['value_field_name'] === 'card_expiry_date'
                  ? [required, cardExpiryValidation]
                  : [required];
              if (
                key['value_field_name'] === 'card_number' &&
                this.props.formValues.card_type === 'VISA_DEBIT_CARD'
              ) {
                validationArray.push(visaDebitCardNoValidation);
              }
              return (
                <Grid.Column computer={7} tablet={8} mobile={16} key={index}>
                  <FieldContainer isSingleRowField={isSingleRowField}>
                    <div
                      className={isSingleRowField ? 'debitCardBox singleRowField' : 'debitCardBox'}
                    >
                      <Field
                        name={key['value_field_name']}
                        type="text"
                        className={'input form-flow disable_border'}
                        component={OutlinedTextFields}
                        maxWidth={isSingleRowField ? '450px' : '325px'}
                        validate={isCardNumberUpdated ? validationArray : []}
                        disabled={isFieldDisabled}
                        placeholder={key.label}
                        isEditable={true}
                        showErrorIcon={true}
                        isVisaCardEditCase={
                          isFieldDisabled && key['value_field_name'] === 'card_number'
                        }
                        normalize={(() => {
                          const { validation } = key;
                          if (validation) {
                            const { exact, max } = validation;
                            return r_maxLength(exact || max || 50);
                          }
                          return r_maxLength(50);
                        })()}
                      />
                    </div>
                    <div className="visaImages">
                      {isFieldDisabled &&
                        key.value_field_name === 'card_number' &&
                        this.props.formValues.routing_config_type === 'VISA_DEBIT_CARD' && (
                          <VisaImage
                            src={VISA_SVG_ICON}
                            style={{
                              height: '12px',
                              width: '36px',
                              marginTop: '5px'
                            }}
                          />
                        )}
                      {key.value_field_name === 'card_number' &&
                        !errors['card_number'] &&
                        show_visa_icon && (
                          <VisaImage
                            src={VISA_SVG_ICON}
                            style={{
                              width: '34px',
                              height: '19px',
                              marginRight: '10px'
                            }}
                          />
                        )}
                      {key.value_field_name === 'card_number' &&
                        !errors['card_number'] &&
                        fast_fund_message && (
                          <FastFundImage src={CORRECT_ICON} style={{ width: '20px' }} />
                        )}
                      {isFieldDisabled &&
                        CARD_SUPPORTED_ROUTING_CODE.includes(
                          this.props.formValues.routing_config_type
                        ) && (
                          <VisaImage
                            src={EDIT_ICON}
                            alt="edit-btn"
                            style={{
                              height: '15px',
                              paddingLeft: '10px',
                              width: '35px',
                              cursor: 'pointer;',
                              marginTop: '4px'
                            }}
                            onClick={this.enableCardEdit}
                          />
                        )}
                    </div>
                  </FieldContainer>
                  {key.value_field_name === 'card_number' &&
                    !errors['card_number'] &&
                    fast_fund_message && (
                      <CardMessageContainer
                        id="fast_fund_message"
                        $isSingleRowField={this.props.isSingleRowField}
                      >
                        {fast_fund_message ? fast_fund_message : null}
                      </CardMessageContainer>
                    )}
                </Grid.Column>
              );
            }
            default:
              break;
          }
        }
      });
      return debitCardRenderHtml;
    }
  };

  createNormalizer = (key) => {
    const validation = key.validation || {};
    const max = validation.exact || validation.max || 50;

    return function (value) {
      if (typeof value !== 'string') return value;

      if (key.label === 'IBAN') {
        const capitalized = value.slice(0, 2).toUpperCase() + value.slice(2);
        return capitalized.slice(0, max);
      }
      return value.slice(0, max);
    };
  };

  renderFunc = (Fields) => {
    const { formValues, isSingleRowField, currency_code } = this.props;
    if (Fields) {
      Fields.sort((a, b) => (a.sequence > b.sequence ? 1 : b.sequence > a.sequence ? -1 : 0));

      return Fields.map((key) => {
        if (key.visible) {
          let isEditable = false;
          let classStyleName = 'mainClass';
          if (
            formValues.currency_code === 'CNY' &&
            formValues.bank_account_country === 'CN' &&
            (key.value_field_name === 'card_issuer_name' || key.label === 'Organization Code')
          ) {
            classStyleName = 'cnyFieldCase';
          }

          if (
            key.value_field_name === 'bank_name' &&
            this.props.countryCode === 'US' &&
            this.props.bank_account_country === 'IN'
          ) {
            isEditable = true;
          }

          if (
            key.value_field_name === 'bank_name' &&
            this.props.bank_account_country === 'PH' &&
            this.props.currency_code === 'PHP'
          ) {
            isEditable = true;
          }

          let params = null;
          if (formValues.details_selected === 'wallet') {
            params = `?country_code=${this.props.bank_account_country}&service_type=Wallets`;
          }

          switch (key.type) {
            case 'text': {
              const isFieldDisabled = key.disabled || false;
              return (
                <FieldContainerBankFields $isSingleRowField={isSingleRowField} key={key}>
                  <div className={classStyleName}>
                    <Field
                      name={key['value_field_name']}
                      type="text"
                      maxWidth={isSingleRowField ? '450px' : '325px'}
                      component={OutlinedTextFields}
                      normalize={this.createNormalizer(key)}
                      validate={[
                        ...(key.validation?.required ? [required] : []),
                        ...(key.label === 'IBAN' ? [validateStartsWithTwoUppercase] : [])
                      ]}
                      disabled={isFieldDisabled}
                      placeholder={key.label}
                      isEditable={isEditable}
                      tooltip={key.tooltip}
                    />
                    {key.label === 'SWIFT' && !isFieldDisabled && (
                      <SwiftMessageContainer id="swift-message" isSingleRowField={isSingleRowField}>
                        Find SWIFT code/BIC{' '}
                        <SwiftLink
                          id="swift-link"
                          href="https://www2.swift.com/bsl/"
                          target="_blank"
                        >
                          here
                        </SwiftLink>
                      </SwiftMessageContainer>
                    )}
                    {key.label === 'IFSC' && (
                      <IFSCSearchButton type="button" onClick={this.showIFSCSearchModal}>
                        Search for IFSC
                      </IFSCSearchButton>
                    )}
                  </div>
                </FieldContainerBankFields>
              );
            }
            case 'dropdown': {
              return (
                <FieldContainerBankFields $isSingleRowField={isSingleRowField} key={key}>
                  <SwiftContainer
                    bankAcccountCountry={this.props.bank_account_country}
                    setZIndex={key['value_field_name'] === 'routing_code_value_1'}
                    isSingleRowField={isSingleRowField}
                  >
                    <Field
                      bindToThisObject={this.props.formValues[key['value_field_name']]}
                      type="text"
                      name={key['value_field_name']}
                      component={
                        key['dropdown_value'] ||
                        (currency_code === 'KES' && formValues.details_selected === 'wallet')
                          ? BoxDropdown
                          : OutlinedTextFields
                      }
                      width="100%"
                      maxWidth={isSingleRowField ? '450px' : '325px'}
                      isSingleRowField={isSingleRowField}
                      customMargin="8px 0 8px 8px"
                      placeholder={key.label}
                      className={`theme-dropdown ${
                        this.props.isPaymentMethod && key['value_field_name'] === 'bank_name'
                          ? 'payment-method-bank-dropdown'
                          : ''
                      }`}
                      validate={[required]}
                      url={
                        key['url']
                          ? params
                            ? `${API_URL_V2}/${key['url']}${params}`
                            : `${API_URL}/${key['url']}`
                          : null
                      }
                      options={key['dropdown_value']}
                      staticValues={key['dropdown_value']}
                      preselect_if_one_item={true}
                      onDropdownChange={(obj) => {
                        this.BankAccountCountryChange(obj, key['value_field_name']);
                        if (this.props.currency_code === 'HKD') {
                          this.props.showAddressForHKD?.(obj.is_address_required);
                        }
                      }}
                      disabled={key.disabled && !key['dropdown_value']}
                      {...this.props}
                    />
                  </SwiftContainer>
                </FieldContainerBankFields>
              );
            }
            case 'searchList': {
              return (
                <FieldContainerBankFields $isSingleRowField={isSingleRowField} key={key}>
                  <div
                    className={`${
                      isSingleRowField ? 'field-container-with-margin' : 'field-container'
                    }`}
                  >
                    <Field
                      bindToThisObject={this.props.formValues[key['value_field_name']]}
                      name={key['value_field_name']}
                      screen={this.props.screen}
                      component={BankListSGNew}
                      maxWidth={isSingleRowField ? '450px' : '325px'}
                      isSingleRowField={isSingleRowField}
                      bank_account_country={this.props.bank_account_country}
                      onBankNameChange={this.onValueChange(key)}
                      onClearBankField={this.onClearBankValue}
                      url={
                        key['url']
                          ? `${key['url']}?country_code=${this.props.bank_account_country}&currency_code=${this.props.currency_code}`
                          : null
                      }
                      validate={[required]}
                      formName={this.props.formName}
                      fieldName={key['value_field_name']}
                      parentDispatch={this.props.dispatch}
                      currency_code={this.props.currency_code}
                      isBranchRequiredCountry={isBranchRequiredCountry(this.props.formValues)}
                    />
                    {this.props.currency_code === 'THB' &&
                      this.state.showTHBUnsupportedNote &&
                      renderTHBUnsupporteBankNote()}
                  </div>
                </FieldContainerBankFields>
              );
            }
            default:
              return null;
          }
        }
        return null;
      });
    }
  };
  showIFSCSearchModal = async () => {
    await ModalFactory.builder(
      (onClose) => (
        <div className="logo-modal ifsc-modal">
          <img
            src={CLOSE_HEAVY_ICON}
            alt="close"
            style={{ alignSelf: 'flex-end' }}
            className="close ifsc-close"
            onClick={() => onClose(false)}
          />
          <IFSCFinder formName={this.props.formName} closeModal={onClose} isNewFlow={true} />
        </div>
      ),
      'insta-modal center-modal',
      true
    );
  };

  payoutMethodSelected = (e, value) => {
    if (value) {
      this.resetFormFields();
      const validation =
        value === 'card'
          ? this.props.debit_validations
          : value === 'bank'
          ? this.props.bank_validations
          : value === 'wallet'
          ? this.props.wallet_validations
          : null;
      this.props.dispatch(change(this.props.formName, 'details_selected', value));
      this.props.dispatch(change(this.props.formName, 'bank_card_validations', validation));
      this.props.dispatch(storeConfigBeneValidation(validation));
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange(value);
    }
  };

  renderPaypoutMethods = (payoutMethods) => {
    if (!payoutMethods) payoutMethods = [];
    return payoutMethods.map((method) => {
      const { text, key, value, subtitle } = method;
      return {
        key,
        value,
        text: text,
        content: (
          <PayoutMethod>
            <RenderTitle id={`title-${value}`}>
              {text}{' '}
              {(value === 'cash' || value === 'money_cash') && <NewIcon src={NEW_ICON}></NewIcon>}
            </RenderTitle>
            <SubTitle id={`sub-title-${value}`}>{subtitle}</SubTitle>
          </PayoutMethod>
        )
      };
    });
  };

  renderAdditionalInfo = (details_selected, bank_account_country) => {
    return (
      <>
        {details_selected === 'card' && bank_account_country === 'IN' && (
          <LabelTextNormal id={`visa-in-text`} paddingTop={'10px'}>
            {`Supports cards of ICICI Bank, Federal Bank, IndusInd Bank, IDBI Bank and Canara Bank.`}
          </LabelTextNormal>
        )}
        {details_selected === 'card' && bank_account_country === 'BD' && (
          <LabelTextNormal id={`visa-bd-text`} paddingTop={'10px'}>
            {`Supports cards of Islami Bank, Brac Bank and Eastern Bank Limited.`}
          </LabelTextNormal>
        )}
        {details_selected === 'card' && bank_account_country === 'NP' && (
          <LabelTextNormal id={`visa-np-text`} paddingTop={'10px'}>
            {`Supported cards of Nepal Arab Bank, Himalayan Bank Limited, Nepal Investment Bank Ltd., Sunrise Bank Ltd.`}
          </LabelTextNormal>
        )}
        {details_selected === 'bank' && !this.props.isNewBeneAddFlow && (
          <LabelText>{`Please enter your recipient’s bank account details`}</LabelText>
        )}
        {details_selected === 'wallet' && (
          <LabelText
            $isSingleRowField={this.props.isSingleRowField}
          >{`Please select your recipient’s mobile money payout network`}</LabelText>
        )}
      </>
    );
  };
  renderBankDetailsDropdownOption = () => {
    const {
      formValues: { routing_config_type, details_selected, bank_account_country },
      isSingleRowField,
      hideRecipientReceivingOptions
    } = this.props;
    return (
      <>
        {!hideRecipientReceivingOptions && (
          <RenderRecevingOptions isSingleRowField={isSingleRowField}>
            <div className="innerBox">
              <Field
                bindToThisObject={this.props.formValues['details_selected']}
                component={BoxDropdown}
                width="100%"
                name="details_selected"
                type="text"
                placeholder={'Recipient Receiving Option'}
                className="theme-dropdown"
                options={this.renderPaypoutMethods(this.state.dropDown)}
                staticValues={this.renderPaypoutMethods(this.state.dropDown)}
                value={details_selected}
                onChange={this.payoutMethodSelected}
                disabled={!!routing_config_type}
                validate={[required]}
              ></Field>
              {this.renderAdditionalInfo(details_selected, bank_account_country)}
            </div>
          </RenderRecevingOptions>
        )}
      </>
    );
  };
  onBankTypeChange = (e, val) => {
    if (val === 'BANK') {
      this.setState({
        isBankChecked: true,
        isDebitCardChecked: false,
        isWalletChecked: false
      });
      this.resetFormFields();
      this.props.dispatch(change(this.props.formName, 'details_selected', 'bank'));
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.bank_validations)
      );
      this.props.dispatch(storeConfigBeneValidation(this.props.bank_validations));
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange('bank');
      this.onBankNameChange();
    } else if (val === 'DEBIT_CARD') {
      this.setState({
        isDebitCardChecked: true,
        isBankChecked: false,
        isWalletChecked: false
      });
      this.resetFormFields();
      this.props.dispatch(change(this.props.formName, 'details_selected', 'card'));
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.debit_validations)
      );
      this.props.dispatch(storeConfigBeneValidation(this.props.debit_validations));
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange('card');
    }
  };
  resetFormFields() {
    let { debitRenderObject } = this.state;
    const { renderObject, isCardNumberUpdated, isBankChecked, isDebitCardChecked } = this.state;
    const { isPartiallyEditable, isCompleteEditable } = this.props;
    renderObject &&
      renderObject.forEach((item) => {
        const valueFieldName = item.value_field_name;
        if (isPartiallyEditable || isCompleteEditable) {
          this.setState({
            [`${valueFieldName}_backup`]: this.props.formValues[valueFieldName]
          });
        }
        this.props.dispatch(change(this.props.formName, valueFieldName, ''));
        this.props.dispatch(untouch(this.props.formName, valueFieldName, ''));
        if (!isBankChecked && (isPartiallyEditable || isCompleteEditable)) {
          this.props.dispatch(
            change(this.props.formName, valueFieldName, this.state[`${valueFieldName}_backup`])
          );
          this.props.dispatch(
            untouch(this.props.formName, valueFieldName, this.state[`${valueFieldName}_backup`])
          );
        }
      });
    if (debitRenderObject) {
      debitRenderObject = debitRenderObject.map((item) => {
        const valueFieldName = item.value_field_name;
        if (isCardNumberUpdated !== false) {
          this.props.dispatch(change(this.props.formName, valueFieldName, ''));
          this.props.dispatch(untouch(this.props.formName, valueFieldName, ''));
        }
        if (
          !isDebitCardChecked &&
          (isPartiallyEditable || isCompleteEditable) &&
          this.state[`${valueFieldName}_backup`] &&
          valueFieldName === 'card_number'
        ) {
          this.setState(
            {
              isCardNumberUpdated: false
            },
            () => this.props.setCardNumberUpdate(false)
          );
          this.props.dispatch(change(this.props.formName, 'is_card_number_updated', false));
        }
        if (
          !isDebitCardChecked &&
          (isPartiallyEditable || isCompleteEditable) &&
          this.state[`${valueFieldName}_backup`]
        ) {
          this.props.dispatch(
            change(this.props.formName, valueFieldName, this.state[`${valueFieldName}_backup`])
          );
          this.props.dispatch(
            untouch(this.props.formName, valueFieldName, this.state[`${valueFieldName}_backup`])
          );
          return { ...item, disabled: true };
        }
        return item;
      });
      this.setState({
        debitRenderObject
      });
    }
    this.props.dispatch(change(this.props.formName, 'details_selected', ''));
  }

  emptyFormFields = (valueFieldName) => {
    this.props.dispatch(change(this.props.formName, valueFieldName, null));
    this.props.dispatch(untouch(this.props.formName, valueFieldName, null));
  };
  clearFormFields = () => {
    this.resetFormFields();
    this.emptyFormFields('bank_card_validations');
    this.props.dispatch(storeConfigBeneValidation(null));
    this.emptyFormFields('bank_name');
    this.emptyFormFields('show_visa_icon');
    this.emptyFormFields('fast_fund_message');
    this.emptyFormFields('beneficiary_bank_address_info');
    this.emptyFormFields('card_type');
    this.emptyFormFields('details_selected');
  };
  isSaveDisabled = () => {
    const { debitRenderObject, isBankChecked, renderObject, beneWalletDetails, isWalletChecked } =
      this.state;
    const { formValues } = this.props;
    let isEmpty = false;
    if (isBankChecked && renderObject) {
      renderObject.forEach((item) => {
        if (!formValues[item.value_field_name]) isEmpty = true;
      });
    } else if (!isBankChecked && debitRenderObject) {
      debitRenderObject.forEach((item) => {
        if (!formValues[item.value_field_name]) isEmpty = true;
      });
    } else if (!isWalletChecked && beneWalletDetails) {
      beneWalletDetails.forEach((item) => {
        if (!formValues[item.value_field_name]) isEmpty = true;
      });
    }
    return isEmpty;
  };
  saveDetails = async (existingItem, existingItemIndex) => {
    const { debitRenderObject, renderObject } = this.state;
    const { formValues, handleError, activateLoader, disableLoader, isMultiBene, loadBene } =
      this.props;
    const {
      details_selected,
      beneficiary_id,
      beneficiary_routing_config_id_bank,
      beneficiary_routing_config_id_debit
    } = formValues;
    const otherProps = {};
    let response = null;
    try {
      activateLoader();
      if (details_selected === 'card') {
        debitRenderObject.forEach((item) => {
          const valueFieldName = item.value_field_name;
          otherProps[valueFieldName] = formValues[valueFieldName];
        });
        const encriptedCardData = encryptDataWithSignature(otherProps.card_number);
        otherProps.card_number = encriptedCardData.encryptedData;
        otherProps.signature = encriptedCardData.signature;
        otherProps['beneficiary_routing_config_id'] = beneficiary_routing_config_id_debit;
        response = await this.props.saveNewBenificiary(beneficiary_id, otherProps);
      } else if (details_selected === 'bank') {
        renderObject.forEach((item) => {
          const valueFieldName = item.value_field_name;
          otherProps[valueFieldName] = formValues[valueFieldName];
        });
        otherProps['beneficiary_routing_config_id'] = beneficiary_routing_config_id_bank;
        response = await this.props.saveNewBenificiary(beneficiary_id, otherProps);
      }

      if (response && response.data && response.data.success) {
        const new_bene_id = response.data.data.beneficiary_id;
        if (existingItem) {
          const newBeneficeryData = await this.props.getBeneficiaryByID(new_bene_id);
          if (newBeneficeryData.data && newBeneficeryData.data.success) {
            const newBeneficiaryDetails = newBeneficeryData.data.data;
            const newItem = {
              ...existingItem,
              ...{ beneficiary_id: new_bene_id }
            };
            newItem['payload']['beneficiary_id'] = new_bene_id;
            newItem['beneficiaryDataToBeShown']['card_details'] = {
              card_no: newBeneficiaryDetails.card_number,
              card_expiry: newBeneficiaryDetails.card_expiry_date,
              card_holder_name: newBeneficiaryDetails.card_holder_name,
              card_issuer_name: newBeneficiaryDetails.card_issuer_name
            };
            newItem['beneficiaryDataToBeShown']['bank_details'] = {
              account_no: newBeneficiaryDetails.bank_account_number,
              bank: newBeneficiaryDetails.bank_name
            };
            await this.props.replaceRecipientListItem(existingItemIndex, newItem);
          }
        }
        this.resetFormFields();
        this.props.dispatch(change(this.props.formName, 'show_bank_details_block', false));
        !isMultiBene && (await this.props.refreshParent());
        this.props.dispatch(change(this.props.formName, 'beneficiary_id', new_bene_id));
        isMultiBene && this.props.onClose();
        loadBene && isMultiBene && loadBene();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      handleError(error);
    }
    disableLoader();
  };
  onBankNameChange = async (item) => {
    const { renderObject } = this.state;
    const { beneDetails } = this.props;

    if (item) {
      const swiftCodes = [];
      this.props.dispatch(change(this.props.formName, 'bank_name', item.bankName));

      item.bicCode.forEach((code, index) => {
        swiftCodes.push({
          key: item.bicCode[index],
          value: item.bicCode[index],
          text: item.bicCode[index]
        });
      });

      // Create new array instead of mutating
      const updatedRenderObject = renderObject.map((itm) => {
        if (itm.label === 'SWIFT' && itm.value_field_name === 'routing_code_value_1') {
          return {
            ...itm,
            dropdown_value: swiftCodes
          };
        }
        return itm;
      });

      if (
        beneDetails &&
        beneDetails.routing_code_type_1 &&
        beneDetails.routing_code_type_1 === 'SWIFT' &&
        beneDetails.routing_code_value_1
      ) {
        this.props.dispatch(
          change(this.props.formName, 'routing_code_value_1', beneDetails.routing_code_value_1)
        );
      }

      if (this.props.currency_code === 'BDT') {
        const response = await this.props.getBankCodeORBranchNames(
          this.props.bank_account_country,
          item.value
        );
        if (response && response.data && response.data.success === true) {
          //  Map again to update branch names
          const finalRenderObject = updatedRenderObject.map((itm) => {
            if (
              itm.value_field_name === 'routing_code_value_2' &&
              itm.label?.toUpperCase() === BRANCH_NAME
            ) {
              return {
                ...itm,
                dropdown_value: response.data.data
              };
            }
            return itm;
          });

          await this.setState({ renderObject: finalRenderObject });

          if (
            beneDetails &&
            beneDetails.routing_code_type_2 &&
            beneDetails.routing_code_type_2 === 'BRANCH_NAME' &&
            beneDetails.routing_code_value_2
          ) {
            this.props.dispatch(
              change(this.props.formName, 'routing_code_value_2', beneDetails.routing_code_value_2)
            );
          }
          return; // Exit early since we already set state
        }
      }

      await this.setState({ renderObject: updatedRenderObject });
    } else if (!item) {
      // Create new array for clearing
      const updatedRenderObject = renderObject.map((itm) => {
        if (itm.label === 'SWIFT' && itm.value_field_name === 'routing_code_value_1') {
          return {
            ...itm,
            dropdown_value: []
          };
        }
        return itm;
      });

      this.props.dispatch(change(this.props.formName, 'routing_code_value_1', ''));
      this.props.dispatch(change(this.props.formName, 'bank_name', ''));
      await this.setState({ renderObject: updatedRenderObject });
    }

    this.renderFunc(this.state.renderObject);
  };

  onClearBankValue = () => {
    this.setState({ showTHBUnsupportedNote: false });
  };
  onValueChange = (config) => async (item) => {
    if (!this.state.hasBankFieldValue) {
      this.setState({ hasBankFieldValue: true });
    }
    this.handleCheck(item?.value, this.state.hasBankFieldValue);

    const { renderObject } = this.state;
    const { beneDetails } = this.props;
    const fieldName = config.value_field_name;
    const populateFieldName = get(config, 'onChange.populate', '');
    const renderFieldName = get(config, 'onChange.render', '');
    if (item) {
      this.props.dispatch(change(this.props.formName, fieldName, item.value));
    } else {
      this.props.dispatch(change(this.props.formName, fieldName, ''));
    }
    if (populateFieldName) {
      if (item) {
        const swiftCodes = [];
        item.bicCode.forEach((code) => {
          swiftCodes.push({
            key: code.key,
            value: code.value,
            text: code.key
          });
        });
        renderObject.forEach((itm) => {
          if (itm.value_field_name === populateFieldName) {
            itm.dropdown_value = swiftCodes;
          }
        });
        if (beneDetails && beneDetails[populateFieldName]) {
          this.props.dispatch(
            change(this.props.formName, populateFieldName, beneDetails[populateFieldName])
          );
        }
      } else if (!item) {
        renderObject.forEach((itm) => {
          if (itm.value_field_name === populateFieldName) {
            itm.dropdown_value = [];
          }
        });
        this.props.dispatch(change(this.props.formName, populateFieldName, ''));
      }
    }

    if (renderFieldName) {
      if (item) {
        const response = await this.props.getBankCodeORBranchNames(
          this.props.bank_account_country,
          item.value
        );
        if (response && response.data && response.data.success === true) {
          // Create a NEW array instead of mutating
          const updatedRenderObject = renderObject.map((itm) => {
            if (itm.value_field_name === renderFieldName) {
              return {
                ...itm,
                dropdown_value: response.data.data
              };
            }
            return itm;
          });

          // Update state with new array
          await this.setState({ renderObject: updatedRenderObject });

          if (beneDetails && beneDetails[renderFieldName]) {
            this.props.dispatch(
              change(this.props.formName, renderFieldName, beneDetails[renderFieldName])
            );
          }
          if (this.props.currency_code === 'HKD') {
            if (
              response.data.data &&
              Array.isArray(response.data.data) &&
              response.data.data.length === 1
            ) {
              this.props.showAddressForHKD?.(response.data.data[0].is_address_required);
            }
          }
        }
      } else if (!item) {
        const updatedRenderObject = renderObject.map((itm) => {
          if (itm.value_field_name === renderFieldName) {
            return {
              ...itm,
              dropdown_value: []
            };
          }
          return itm;
        });

        await this.setState({ renderObject: updatedRenderObject });
        this.props.dispatch(change(this.props.formName, renderFieldName, ''));
      }
    }
    this.renderFunc(this.state.renderObject);
  };

  renderWalletFields = (fields = []) => {
    const {
      formValues: { mobile_country_code, country_code, mobile_number },
      mob_code,
      isSingleRowField
    } = this.props;
    return (
      <WalletWrapper isSingleRowField={isSingleRowField}>
        <div className="wallet-payout">{this.renderFunc(fields)}</div>
        <p style={{ marginTop: '20px' }}>Mobile number linked to payout network</p>
        <div className="mobile-field">
          <Field
            bindToThisObject={mobile_country_code}
            dependedOnObject={country_code}
            name="mobile_country_code"
            width="90px"
            type="text"
            boxSize={'small'}
            validate={[required]}
            component={BoxDropdown}
            disabled={true}
            placeholder="Code"
            url={API_URL + '/country/phone-code'}
            selectedLabel={mob_code}
          />
          <div className="mobile-number-field-wrapper">
            <InputField
              className="mobile-number-field"
              disabled={true}
              label={'Mobile number'}
              input={{
                name: 'mobile_number',
                value: mobile_number || ''
              }}
            />
          </div>
        </div>
        <p>In case of change in number, change recipient’s mobile number from recipient info. </p>
      </WalletWrapper>
    );
  };

  render() {
    const {
      isBlock,
      isPaymentMethod,
      isMultiBene,
      formValues: { details_selected },
      renderAdditionalField,
      beneCashPayoutDetails,
      isSingleRowField,
      hideRecipientReceivingOptions
    } = this.props;
    const { renderObject, debitCardFields, isBankChecked, dropDown, walletRenderObject } =
      this.state;
    const { formValues, countryCode } = this.props;
    if (!renderObject && !beneCashPayoutDetails && !walletRenderObject) return null;
    const isDisbled = this.isSaveDisabled();
    return (
      <Grid.Row
        className={
          'form-row bank-details' +
          (isBlock ? '' : ' zero-top-padding') +
          (isPaymentMethod ? ' bank-details-container' : '')
        }
      >
        {isBlock && !isPaymentMethod && !hideRecipientReceivingOptions && (
          <Grid.Column width={16}>
            {debitCardFields || dropDown.length > 1 ? (
              <>
                <Title className="form-flow-header">{'Recipient’s Receiving Options'}</Title>
              </>
            ) : renderObject ? (
              <Title className="form-flow-header">{'Bank details'}</Title>
            ) : (
              <Title className="form-flow-header">
                {'Recipient receiving method: Cash pickup'}
              </Title>
            )}
          </Grid.Column>
        )}
        {renderAdditionalField && (
          <BankDetailsContainer
            isBranchRequiredCountry={isBranchRequiredCountry(formValues)}
            account_type={formValues.account_type}
            currency_code={formValues.currency_code}
            bank_account_country={formValues.bank_account_country}
            isSingleRowField={this.props.isSingleRowField}
          >
            {this.props.isNewBeneAddFlow &&
              this.renderAdditionalInfo(details_selected, formValues.bank_account_country)}
            {this.renderFunc(renderObject)}
          </BankDetailsContainer>
        )}
        {isPaymentMethod && (
          <div className={isMultiBene ? 'bank-details-holder-no-border' : 'bank-details-holder'}>
            {debitCardFields && this.renderBankDetailsDropdownOption()}
            <div
              className={'bank-details-section'}
              style={debitCardFields ? { marginTop: 20 } : { marginTop: 0 }}
            >
              {isBankChecked ? (
                <BankDetailsContainer
                  isBranchRequiredCountry={isBranchRequiredCountry(formValues)}
                  account_type={formValues.account_type}
                  currency_code={formValues.currency_code}
                  bank_account_country={formValues.bank_account_country}
                  isSingleRowField={this.props.isSingleRowField}
                >
                  {this.props.isNewBeneAddFlow &&
                    this.renderAdditionalInfo(details_selected, formValues.bank_account_country)}
                  {this.renderFunc(renderObject, this.props.countryCode)}
                </BankDetailsContainer>
              ) : (
                this.renderDebitCard()
              )}
              {!isBankChecked &&
                get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
                  <StyledGrid width={16} className="align-items-center">
                    <TNCText
                      style={{
                        fontSize: 14,
                        paddingTop: isBankChecked ? 20 : 0
                      }}
                      isSingleRowField={isSingleRowField}
                    >
                      By proceeding, you agree to all
                      <Link to={VISA_TNC_LINK} target={'_blank'} style={{ color: '#009adf' }}>
                        Terms & Conditions
                      </Link>
                    </TNCText>
                  </StyledGrid>
                )}

              <ButtonContainer marginTop={!isMultiBene ? 10 : 50}>
                <SaveButton
                  type="button"
                  bgColor={'#e8e8e8'}
                  color={'#9b9b9b'}
                  onClick={() => {
                    this.clearFormFields();
                    this.props.closeBankDetailsBlock();
                  }}
                >
                  Cancel
                </SaveButton>
                <SaveButton
                  type="button"
                  disabled={isDisbled}
                  onClick={() =>
                    this.saveDetails(this.props.existingItem, this.props.existingItemIndex)
                  }
                >
                  Save Details
                </SaveButton>
              </ButtonContainer>
            </div>
          </div>
        )}
        {!isPaymentMethod && dropDown.length > 1 && this.renderBankDetailsDropdownOption()}
        {details_selected === 'bank' && !renderAdditionalField && (
          <BankDetailsContainer
            isBranchRequiredCountry={isBranchRequiredCountry(formValues)}
            account_type={formValues.account_type}
            currency_code={formValues.currency_code}
            bank_account_country={formValues.bank_account_country}
            isSingleRowField={this.props.isSingleRowField}
          >
            {this.props.isNewBeneAddFlow &&
              this.renderAdditionalInfo(details_selected, formValues.bank_account_country)}
            {this.renderFunc(renderObject)}
          </BankDetailsContainer>
        )}
        {details_selected === 'card' && !renderAdditionalField && this.renderDebitCard()}
        {details_selected === 'wallet' &&
          !renderAdditionalField &&
          this.renderWalletFields(walletRenderObject)}
        {details_selected === 'card' &&
          !isPaymentMethod &&
          !renderAdditionalField &&
          get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
            <Grid.Column width={16} className="align-items-center">
              <TNCText isSingleRowField={isSingleRowField}>
                By proceeding, you agree to all{' '}
                <Link to={VISA_TNC_LINK} target={'_blank'} style={{ color: '#009adf' }}>
                  Terms & Conditions
                </Link>
              </TNCText>
              <FAQText isSingleRowField={isSingleRowField}>
                Please check our
                <a
                  href={VISA_FAQ_LINKS[countryCode || 'SG']}
                  target={'_blank'}
                  style={{ color: '#009adf' }}
                  rel="noopener noreferrer"
                >
                  {' '}
                  FAQs
                </a>{' '}
                {`for more details.`}
              </FAQText>
            </Grid.Column>
          )}
      </Grid.Row>
    );
  }
}

BankDetailsBlock.propTypes = {
  formValues: PropTypes.any,
  renderFields: PropTypes.any,

  dispatch: PropTypes.func,
  isBlock: PropTypes.bool,
  currency_code: PropTypes.string,
  formName: PropTypes.string,
  getBankFields: PropTypes.func,
  countryCode: PropTypes.any,
  bank_account_country: PropTypes.any,
  debitCardFields: PropTypes.any,
  bank_validations: PropTypes.any,
  debit_validations: PropTypes.any,
  isPaymentMethod: PropTypes.any,
  handleError: PropTypes.any,
  activateLoader: PropTypes.any,
  disableLoader: PropTypes.any,
  isMultiBene: PropTypes.any,
  saveNewBenificiary: PropTypes.any,
  refreshParent: PropTypes.any,
  onClose: PropTypes.func,
  existingItem: PropTypes.any,
  screen: PropTypes.any,
  existingItemIndex: PropTypes.any,
  getBeneficiaryByID: PropTypes.any,
  replaceRecipientListItem: PropTypes.any,
  isPartiallyEditable: PropTypes.bool,
  isCompleteEditable: PropTypes.bool,
  errors: PropTypes.any,
  closeBankDetailsBlock: PropTypes.any,
  loadBene: PropTypes.any,
  fastFundsIndicator: PropTypes.string,
  setCardNumberUpdate: PropTypes.func,
  onTransferMoneyOptionChange: PropTypes.func,
  beneDetails: PropTypes.any,
  beneCashPayoutDetails: PropTypes.any,
  renderAdditionalField: PropTypes.bool,
  getBankCodeORBranchNames: PropTypes.func,
  showAddressForHKD: PropTypes.func,
  beneWalletDetails: PropTypes.any,
  mob_code: PropTypes.string,
  wallet_validations: PropTypes.any,
  userTier: PropTypes.string,
  isSingleRowField: PropTypes.bool,
  hideRecipientReceivingOptions: PropTypes.bool,
  isVopTransactionFlow: PropTypes.bool,
  isNewBeneAddFlow: PropTypes.bool,
  fields: PropTypes.object,
  show_loader: PropTypes.bool,
  onCountryCurrencyPairChange: PropTypes.func
};

function mapStateToProps(store) {
  const {
    rootReducer: {
      bankValidationsReducer: {
        asyncResponse: { fastFundsIndicator = '' }
      },
      userDataReducer: { beneDetails },
      userSessionReducer: {
        user_session: { tier: userTier }
      }
    }
  } = store;

  return {
    fastFundsIndicator,
    beneDetails,
    userTier
  };
}
export default connect(mapStateToProps, {
  saveNewBenificiary,
  getBeneficiaryByID,
  replaceRecipientListItem,
  setCardNumberUpdate,
  getBankCodeORBranchNames
})(BankDetailsBlock);
